import React from 'react';
import PropTypes from 'prop-types';

import { styles } from './styles';

export default function Shell({ children }) {
  return (
    <main data-testid="portfolio-manager-page" style={styles.page}>
      <div style={styles.shell}>
        {children}
      </div>
    </main>
  );
}

Shell.propTypes = {
  children: PropTypes.node.isRequired,
};
